import { render, staticRenderFns } from "./proejct.vue?vue&type=template&id=ee845f0e&scoped=true&"
import script from "./proejct.vue?vue&type=script&lang=js&"
export * from "./proejct.vue?vue&type=script&lang=js&"
import style0 from "./proejct.vue?vue&type=style&index=0&id=ee845f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee845f0e",
  null
  
)

export default component.exports